import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const PageContainer = styled.div`
  padding: 0;
  min-height: 100vh;

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #333;
    border-top: 3px solid #ff6b35;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    margin: 0 auto 1rem;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;
export const BackLink = styled.div`
  z-index: 100;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
  color: #ff6b35;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 25px;
  background: rgba(26, 26, 26, 0.8);
  border: 1px solid rgba(255, 107, 53, 0.3);
  text-decoration: none;
  width: fit-content;
  transition: 0.3s;
  &:hover {
    background: #ff6b35;
    color: #fff;
    transform: translateX(-5px);
  }
`;

export const PageTitle = styled.h1`
  color: #ff6b35;
  font-size: 2rem;
  font-weight: bold;
  margin: 2rem 0 0 0;
`;

export const SaveButton = styled.button`
  background: ${(props) => (props.$hasChanges ? "#ff6b35" : "#666")};
  color: #ffffff;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover:not(:disabled) {
    background: #e55a2b;
    transform: translateY(-2px);
  }
`;

export const FormCard = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid #333;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormLabel = styled.label`
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
`;

export const FormInput = styled.input`
  background: #333;
  border: 1px solid #555;
  border-radius: 6px;
  padding: 0.75rem;
  color: #ffffff;
  font-size: 1rem;
  transition: border-color 0.3s ease;

  width: 100%;
  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #888;
  }
`;

export const FormTextarea = styled.textarea`
  background: #333;
  border: 1px solid #555;
  border-radius: 6px;
  padding: 0.75rem;
  color: #ffffff;
  font-size: 1rem;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #888;
  }
`;

export const FormSelect = styled.select`
  background: #333;
  border: 1px solid #555;
  border-radius: 6px;
  padding: 0.75rem;
  color: #ffffff;
  font-size: 1rem;
  width: 100%;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  option {
    background: #333;
    color: #ffffff;
  }
`;

export const Relative = styled.div`
  width: 100%;
  position: relative;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff6b35;
  font-weight: 500;
  cursor: pointer;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #ff6b35;
    cursor: pointer;
  }
`;

export const EditorContainer = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  border: 1px solid #333;
  overflow: hidden;
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #333;
  background: #2a2a2a;
`;

export const Tab = styled.button`
  background: ${(props) => (props.$active ? "#ff6b35" : "transparent")};
  color: ${(props) => (props.$active ? "#ffffff" : "#ccc")};
  border: none;
  padding: 1rem 2rem;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) =>
      props.$active ? "#ff6b35" : "rgba(255, 107, 53, 0.1)"};
    color: ${(props) => (props.$active ? "#ffffff" : "#ff6b35")};
  }
`;

export const TabContent = styled.div`
  min-height: 500px;
`;

export const EditorGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 788px;

  height: 600px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    height: auto;
  }
`;

export const EditorColumn = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #333;

  @media (max-width: 1200px) {
    border-right: none;
    border-bottom: 1px solid #333;
  }
`;

export const PreviewColumn = styled.div`
  padding: 1rem;
  background: #0a0a0a;
  width: 100%;
  overflow-y: auto;
`;

export const ToolbarContainer = styled.div`
  border-bottom: 1px solid #333;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #2a2a2a;
  flex-wrap: wrap;
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding-right: 0.5rem;
  border-right: 1px solid #555;

  &:last-child {
    border-right: none;
  }
`;

export const ToolbarButton = styled.button`
  background: #333;
  color: #ccc;
  border: 1px solid #555;
  border-radius: 4px;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: bold;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    border-color: #ff6b35;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const EditorTextarea = styled.textarea`
  background: #1a1a1a;
  border: none;
  padding: 2rem;
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.6;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
  resize: none;
  flex: 1;
  min-height: 400px;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #888;
  }
`;

export const PreviewCard = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #333;
  width: 100%;
  height: fit-content;
  position: sticky;
  top: 1rem;
`;

export const PreviewTitle = styled.h3`
  color: #ff6b35;
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
`;

export const PreviewContent = styled.div`
  max-width: 788px;
`;

// Preview News Card Components
export const PreviewNewsCard = styled.article`
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid #333;
  transition: all 0.3s ease;
  height: fit-content;
`;

export const NewsImage = styled.div`
  height: 200px;
  background: linear-gradient(45deg, #333, #555, #ff6b35);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 107, 53, 0.3),
      rgba(0, 0, 0, 0.6)
    );
  }
`;

export const NewsDate = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(255, 107, 53, 0.95);
  color: #ffffff;
  padding: 0.5rem 0.8rem;
  border-radius: 8px;
  font-weight: bold;
  z-index: 3;
  font-size: 0.8rem;
`;

export const NewsType = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: ${({ type }) =>
    type === "concert"
      ? "#27ae60"
      : type === "album"
      ? "#9b59b6"
      : type === "interview"
      ? "#3498db"
      : type === "video"
      ? "#e74c3c"
      : type === "award"
      ? "#f39c12"
      : "#ff6b35"};
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 3;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const NewsContent = styled.div`
  padding: 1.5rem;
`;

export const BandTag = styled.span`
  background: #ff6b35;
  color: #ffffff;
  padding: 0.2rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 0.8rem;
`;

export const NewsTitle = styled.h2`
  color: #ffffff;
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  font-weight: bold;
  line-height: 1.3;
`;

export const NewsLocation = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
  }
`;

export const NewsTime = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  margin-bottom: 1rem;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
  }
`;

export const NewsExcerpt = styled.div`
  color: #cccccc;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1rem;

  h2,
  h3 {
    color: #ffffff;
    margin: 1rem 0 0.5rem 0;
  }

  h2 {
    font-size: 1.2rem;
    color: #ff6b35;
  }

  h3 {
    font-size: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  blockquote {
    border-left: 3px solid #ff6b35;
    padding-left: 1rem;
    margin: 1rem 0;
    font-style: italic;
    background: rgba(255, 107, 53, 0.1);
    padding: 0.5rem 1rem;
    border-radius: 0 8px 8px 0;
  }

  ul,
  ol {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  li {
    margin-bottom: 0.3rem;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 1rem 0;
  }

  a {
    color: #ff6b35;
    text-decoration: none;
    border-bottom: 1px dotted #ff6b35;
  }

  a:hover {
    color: #ffffff;
    border-bottom-color: #ffffff;
  }
`;

export const NewsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid #333;
`;

export const NewsActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const ArticleTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

export const Tag = styled.span`
  background: linear-gradient(
    135deg,
    rgba(255, 107, 53, 0.2),
    rgba(255, 107, 53, 0.1)
  );
  color: #ff6b35;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid rgba(255, 107, 53, 0.3);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
  }
`;

export const ActionBtn = styled.button`
  background: ${({ $primary }) => ($primary ? "#ff6b35" : "transparent")};
  color: ${({ $primary }) => ($primary ? "#ffffff" : "#ff6b35")};
  border: 2px solid #ff6b35;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: bold;
  font-size: 0.9rem;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateY(-1px);
  }
`;
